export default "/static/src/images/OB_PrimaryLogo_03-White.png";